import React, { useState, useRef, useEffect } from 'react'
import WrapIcon from '../elements/WrapIcon'

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { clsx, getBodyScrollTop } from '../../utils/helper'
import useDevices from '../../hooks/useDevices'

import IconCloche from '../../assets/icons/IconCloche'
import IconClose from '../../assets/icons/IconClose'
import { useTranslation } from 'react-i18next'

const MenuItem = ({ group, onClick, isActive, id }) => {
    return (
        <div id={id} onClick={e => onClick(e, group.id)} className={clsx(['menu-item', isActive && 'active'])}>
            <div className="item-name">{group.name}</div>
            <div className="item-count">
                {group.count}
                <i className="ml-3 fas fa-angle-right"></i>
            </div>
        </div>
    )
}

const MenuGroupFood = ({ groups, handleSetDisplayGroup, displayGroup, cartAmount }) => {
    const [showMenu, setShowMenu] = useState(false)
    const menuListRef = useRef()
    const toggleRef = useRef()

    const { t } = useTranslation()

    const { isMobile } = useDevices()

    const toggleShowMenu = e => {
        e.preventDefault()
        e.stopPropagation()
        setShowMenu(prev => !prev)
    }

    const handleItemClick = (e, groupId) => {
        e.preventDefault()
        e.stopPropagation()
        setShowMenu(false)
        handleSetDisplayGroup(groupId)
    }

    useEffect(() => {
        setShowMenu(false)
    }, [isMobile])

    useEffect(() => {
        const clickOutside = e => {
            e && e.stopPropagation()
            // e && e.preventDefault()

            if (
                !menuListRef.current ||
                menuListRef.current.contains(e.target) ||
                toggleRef.current.contains(e.target)
            ) {
                return
            }
            setShowMenu(false)
        }
        document.addEventListener('mousedown', clickOutside)

        if (showMenu) {
            menuListRef.current && disableBodyScroll(menuListRef.current)
            getBodyScrollTop().style.overflow = 'hidden'

            const menuSelected = document.getElementById(`m-menu-${displayGroup}`)
            if (displayGroup !== -1 && menuSelected) {
                menuListRef.current.scrollTop = menuSelected.offsetTop
            }
        }

        return () => {
            document.removeEventListener('mousedown', clickOutside)
            getBodyScrollTop().style.overflow = null

            clearAllBodyScrollLocks()
        }
    }, [showMenu])

    return (
        <>
            {showMenu && <div className="menu-backdrop" />}
            <div className="menu-mobile">
                {showMenu && (
                    <>
                        <div ref={menuListRef} className="group-list">
                            {groups.map((group, i) => (
                                <MenuItem
                                    id={`m-menu-${group.id}`}
                                    onClick={handleItemClick}
                                    key={group.id}
                                    group={group}
                                    isActive={(displayGroup === group.id) || (displayGroup === -1 && !i)}
                                />
                            ))}
                        </div>
                        <div className="arrow-down"></div>
                    </>
                )}
                <div
                    ref={toggleRef}
                    className="group-toggle"
                    onClick={toggleShowMenu}
                >
                    {showMenu ? (
                        <>
                            <WrapIcon
                                icon={IconClose}
                                size="14px"
                                color="ffffff"
                                className="mr-2"
                            />
                            <span>{t('shortcutCartMobile.btnCloseMenu')}</span>
                        </>
                    ) : (
                        <>
                            <WrapIcon
                                icon={IconCloche}
                                size="28px"
                                color="ffffff"
                                className="mr-1"
                            />
                            <span>{t('shortcutCartMobile.btnOpenMenu')}</span>
                        </>
                    )}
                </div>
            </div>
        </>
    )
}

export default MenuGroupFood
